module.exports = __webpack_public_path__ + "static/media/graph-workshop-lab.png";